import { render, staticRenderFns } from "./ClientStats.vue?vue&type=template&id=ab0c94b4&scoped=true"
import script from "./ClientStats.vue?vue&type=script&lang=js"
export * from "./ClientStats.vue?vue&type=script&lang=js"
import style0 from "./ClientStats.vue?vue&type=style&index=0&id=ab0c94b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0c94b4",
  null
  
)

export default component.exports